<script lang="ts" setup>
import RegisterAccountDisclaimer from "~/components/pages/registerAccount/components/registerAccountDisclaimer/RegisterAccountDisclaimer.vue";
import LoginBrand from "~/components/pages/login/LoginBrand.vue";
</script>

<template>
  <NuxtLayout name="dual-color-container">
    <template #left-content>
      <div class="w-full h-screen overflow-auto p-8 max-lg:p-4">
        <div
          class="self-center w-full flex flex-col justify-between gap-4 pt-0 md:pt-4 md:gap-2"
        >
          <LoginBrand />
          <slot />
        </div>
      </div>
    </template>
    <template #right-content>
      <RegisterAccountDisclaimer />
    </template>
  </NuxtLayout>
</template>
